/* eslint-disable @typescript-eslint/naming-convention */
import { MonitorItem } from 'src/app/monitor/models/monitor-item';
import { InitConfiguration } from '../../distribution/models/init-configuration';
import { DataFieldValue } from '../../shared/datafields/models';
import { ScheduleItem } from '../../shared/scheduling/models/schedule-item';

export interface TransportConfig {
  Id?: number;
  Name: string;
  DisplayAddress: string;
  TransportTypeId: number;
  IsDeleted: boolean;
  MonitorItem?: MonitorItem;
}

export class TransportOutConfiguration implements TransportConfig {
  constructor(data: Partial<TransportOutConfiguration> = {}) {
    Object.assign(this, data);
  }

  Name = '';
  DisplayAddress = '';
  TransportTypeId = 0;
  TransportTypeName = '';
  IsDeleted = false;
  MonitorItem: MonitorItem = null;

  Id: number = null;
  PartnerId: number = null;
  PartnerSystemId: number = null;
  BlockedByImport = false;

  CreatedDate: Date = new Date();
  CreatedBy: number = 0;
  UpdatedDate: Date = new Date();
  UpdatedBy: number = 0;
}

export class TransportInConfiguration implements TransportConfig {
  constructor(data: Partial<TransportInConfiguration> = {}) {
    Object.assign(this, data);
  }

  Id?: number;
  Name = '';
  DisplayAddress = '';
  TransportTypeId = 0;
  IsDeleted = false;
  MonitorItem: MonitorItem = null;

  InitConfiguration = {} as InitConfiguration;
  FrequencyInSeconds = 300;
  Schedule = new ScheduleItem();
}

export interface TransportOutConfigurationAndValues {
  TransportConfiguration: TransportOutConfiguration;
  DataFieldValues: DataFieldValue[];
  MonitorConfigValues: DataFieldValue[];
}

export interface TransportInConfigurationAndValues {
  TransportConfiguration: TransportInConfiguration;
  DataFieldValues: DataFieldValue[];
  MonitorConfigValues: DataFieldValue[];
}

export interface TransportOutConfigurationSearchResult {
  TransportOutConfigurations: TransportOutConfiguration[];
  IsTransportOutConfigurationSearchResultRestricted: boolean;
}
